import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, getUserId } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const next = sessionStorage.getItem("tao_post_login") || "/aventures";
    if (!sid) {
      navigate(next, { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sid, guest_id: getUserId() })
      .then(({ data }) => {
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        sessionStorage.removeItem("tao_post_login");
        navigate(next, { replace: true });
      })
      .catch(() => navigate("/connexion", { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center font-sans text-[#1F2A24]/70" data-testid="auth-callback">
      Connexion en cours…
    </div>
  );
}
